import React from 'react'

type IconProps = {
    className?: string
}

export const SidebarIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width="16"
        height="32"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M5.55 10.35L0.749999 5.55L5.55 0.75M12.75 10.35L7.95 5.55L12.75 0.75"
            stroke="#94A3B8"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
